export const SET_CURRENT_STEP = 'SET_CURRENT_STEP'
export const MERGE_STEP_FORM = 'MERGE_STEP_FORM'
export const RESET_STEP_FORM = 'RESET_STEP_FORM'
export const RESET_UPLOAD_PGR = 'RESET_UPLOAD_PGR'
export const SET_UPLOAD_PGR_ID = 'SET_UPLOAD_PGR_ID'
export const SET_ID_ENVIO_CRIPTOGRAFADO = 'SET_ID_ENVIO_CRIPTOGRAFADO'
export const SET_ENVIO_STATUS = 'SET_ENVIO_STATUS'
export const SET_DT_CRIACAO_ENVIO = 'SET_DT_CRIACAO_ENVIO'
export const SET_COMPLETED_STEPS = 'SET_COMPLETED_STEPS'
export const SET_COMMITTED_SNAPSHOT = 'SET_COMMITTED_SNAPSHOT'

export const UPLOAD_PGR_STEPS_COUNT = 7
export const UPLOAD_PGR_PROTECTED_STEPS = [4, 5, 6]

export function hasUploadPgrOcrPayload(ocr) {
  if (ocr == null) return false
  if (Array.isArray(ocr)) return ocr.length > 0
  if (typeof ocr === 'object') return Object.keys(ocr).length > 0
  return false
}

function cloneFormSlice(data) {
  return JSON.parse(JSON.stringify(data))
}

/** Quando a API não envia `resume_step`, deduz o passo do wizard pelo estado do envio. */
function inferResumeStepFromPayload(payload) {
  const status = payload.status || 'em_andamento'
  if (status === 'finalizado') return 7
  if (payload.dados_corrigidos?.pgr?.planoAcao?.length) return 6
  if (payload.dados_corrigidos?.itensSetorFuncao?.length) return 5
  const extracaoOk = hasUploadPgrOcrPayload(payload.dados_extracao_ocr)
  if (extracaoOk) return 4
  if (status === 'em_analise') return 3
  if (payload.id_mapeamento != null && payload.id_mapeamento !== '') return 2
  return 1
}

function resolveResumeStep(payload) {
  const raw = payload.resume_step
  const n = Number(raw)
  if (raw != null && raw !== '' && Number.isFinite(n) && n >= 1 && n <= UPLOAD_PGR_STEPS_COUNT) {
    return n
  }
  return inferResumeStepFromPayload(payload)
}

const createInitialForms = () => ({
  1: {
    empresasSelecionadas: [],
    pgrFile: null,
    arquivoPgrNomeExistente: null,
  },
  2: {
    mapeamento: null,
  },
  3: {
    analiseIaStatus: null,
    extracaoSolicitada: false,
  },
  4: {
    itensSetorFuncao: [],
    dadosExtracaoOcrSnapshot: null,
  },
  5: {
    pgr: null,
    origem: null,
  },
  6: {
    resumo: null,
    aplicado: false,
    pgrsGerados: [],
  },
  7: {},
})

const getDefaultState = () => ({
  idUploadPgr: null,
  idEnvioCriptografado: null,
  envioStatus: null,
  dtCriacaoEnvio: null,
  currentStep: 1,
  completedSteps: [],
  committedSnapshots: createInitialForms(),
  forms: createInitialForms(),
})

const state = getDefaultState()

const mutations = {
  [SET_CURRENT_STEP]: (state, step) => {
    const n = Number(step)
    if (Number.isFinite(n) && n >= 1 && n <= UPLOAD_PGR_STEPS_COUNT) {
      state.currentStep = n
    }
  },
  [MERGE_STEP_FORM]: (state, { step, data }) => {
    const s = Number(step)
    if (s < 1 || s > UPLOAD_PGR_STEPS_COUNT || !state.forms[s]) return
    state.forms[s] = { ...state.forms[s], ...data }
  },
  [RESET_STEP_FORM]: (state, { step, data }) => {
    const s = Number(step)
    if (s < 1 || s > UPLOAD_PGR_STEPS_COUNT) return
    state.forms[s] = cloneFormSlice(data)
  },
  [RESET_UPLOAD_PGR]: (state) => {
    Object.assign(state, getDefaultState())
  },
  [SET_UPLOAD_PGR_ID]: (state, id) => {
    state.idUploadPgr = id != null ? Number(id) : null
  },
  [SET_ID_ENVIO_CRIPTOGRAFADO]: (state, token) => {
    state.idEnvioCriptografado = token != null && String(token).trim() !== '' ? String(token) : null
  },
  [SET_ENVIO_STATUS]: (state, status) => {
    state.envioStatus = status != null ? String(status) : null
  },
  [SET_DT_CRIACAO_ENVIO]: (state, value) => {
    state.dtCriacaoEnvio = value != null ? value : null
  },
  [SET_COMPLETED_STEPS]: (state, steps) => {
    state.completedSteps = Array.isArray(steps) ? [...steps] : []
  },
  [SET_COMMITTED_SNAPSHOT]: (state, { step, data }) => {
    const s = Number(step)
    if (s < 1 || s > UPLOAD_PGR_STEPS_COUNT) return
    state.committedSnapshots[s] = cloneFormSlice(data)
  },
}

const getters = {
  currentStep: (state) => state.currentStep,
  idUploadPgr: (state) => state.idUploadPgr,
  idEnvioCriptografado: (state) => state.idEnvioCriptografado,
  envioStatus: (state) => state.envioStatus,
  dtCriacaoEnvio: (state) => state.dtCriacaoEnvio,
  isEnvioFinalizado: (state) => state.envioStatus === 'finalizado',
  completedSteps: (state) => state.completedSteps,
  isStepCompleted: (state) => (step) => state.completedSteps.includes(Number(step)),
  formByStep: (state) => (step) => state.forms[Number(step)] || {},
  uploadForm: (state) => state.forms[1],
}

const actions = {
  resetUploadPgr({ commit }) {
    commit(RESET_UPLOAD_PGR)
  },

  hydrateFromEnvioApi({ commit, state }, payload) {
    const prevStep = state.currentStep
    const prevUploadId = state.idUploadPgr

    commit(RESET_UPLOAD_PGR)
    commit(SET_UPLOAD_PGR_ID, payload.id)
    commit(SET_ENVIO_STATUS, payload.status || 'em_andamento')
    commit(SET_DT_CRIACAO_ENVIO, payload.dt_criacao || null)
    if (payload.id_envio_criptografado) {
      commit(SET_ID_ENVIO_CRIPTOGRAFADO, payload.id_envio_criptografado)
    }

    const resolved = resolveResumeStep(payload)
    const sameEnvio =
      prevUploadId != null && Number(prevUploadId) === Number(payload.id)
    const step = sameEnvio ? Math.max(Number(prevStep) || 1, resolved) : resolved
    commit(SET_CURRENT_STEP, step)

    commit(MERGE_STEP_FORM, {
      step: 1,
      data: {
        empresasSelecionadas: Array.isArray(payload.empresas)
          ? payload.empresas.map((e) => ({ ...e }))
          : [],
        pgrFile: null,
        arquivoPgrNomeExistente: payload.arquivo_nome_exibicao || null,
      },
    })
    if (payload.mapeamento && payload.mapeamento.id != null) {
      commit(MERGE_STEP_FORM, {
        step: 2,
        data: { mapeamento: { ...payload.mapeamento } },
      })
    }

    const extracaoOk = hasUploadPgrOcrPayload(payload.dados_extracao_ocr)
    if (Array.isArray(payload.pgrs_gerados) && payload.pgrs_gerados.length) {
      commit(MERGE_STEP_FORM, {
        step: 6,
        data: {
          aplicado: true,
          pgrsGerados: payload.pgrs_gerados.map((p) => ({ ...p })),
        },
      })
    }

    if (payload.dados_corrigidos?.itensSetorFuncao?.length) {
      const itensCorrigidos = payload.dados_corrigidos.itensSetorFuncao.map((item) => ({ ...item }))
      commit(MERGE_STEP_FORM, {
        step: 4,
        data: { itensSetorFuncao: itensCorrigidos },
      })
      commit(SET_COMMITTED_SNAPSHOT, {
        step: 4,
        data: { itensSetorFuncao: itensCorrigidos },
      })
      if (!state.completedSteps.includes(4)) {
        commit(SET_COMPLETED_STEPS, [...state.completedSteps, 4].sort((a, b) => a - b))
      }
    }

    if (payload.dados_corrigidos?.pgr?.planoAcao?.length) {
      const pgrCorrigido = cloneFormSlice(payload.dados_corrigidos.pgr)
      commit(MERGE_STEP_FORM, {
        step: 5,
        data: { pgr: pgrCorrigido, origem: 'dados_corrigidos' },
      })
      commit(SET_COMMITTED_SNAPSHOT, {
        step: 5,
        data: { pgr: pgrCorrigido, origem: 'dados_corrigidos' },
      })
      if (!state.completedSteps.includes(5)) {
        commit(SET_COMPLETED_STEPS, [...state.completedSteps, 5].sort((a, b) => a - b))
      }
    }

    if (extracaoOk) {
      commit(MERGE_STEP_FORM, {
        step: 4,
        data: { dadosExtracaoOcrSnapshot: payload.dados_extracao_ocr },
      })
      commit(MERGE_STEP_FORM, {
        step: 3,
        data: { analiseIaStatus: 'sent', extracaoSolicitada: true },
      })
    } else if (payload.status === 'em_analise') {
      commit(MERGE_STEP_FORM, {
        step: 3,
        data: { extracaoSolicitada: true },
      })
    }
  },

  saveUploadForm({ commit }, data) {
    commit(MERGE_STEP_FORM, { step: 1, data })
  },

  mergeStepForm({ commit }, payload) {
    commit(MERGE_STEP_FORM, payload)
  },

  setUploadPgrId({ commit }, id) {
    commit(SET_UPLOAD_PGR_ID, id)
  },

  setIdEnvioCriptografado({ commit }, token) {
    commit(SET_ID_ENVIO_CRIPTOGRAFADO, token)
  },

  setEnvioStatus({ commit }, status) {
    commit(SET_ENVIO_STATUS, status)
  },

  setDtCriacaoEnvio({ commit }, value) {
    commit(SET_DT_CRIACAO_ENVIO, value)
  },

  setCurrentStep({ commit }, step) {
    commit(SET_CURRENT_STEP, step)
  },

  commitProtectedStep({ commit, state }, { step, data }) {
    const s = Number(step)
    if (!UPLOAD_PGR_PROTECTED_STEPS.includes(s)) return

    const payload = cloneFormSlice(data)
    commit(MERGE_STEP_FORM, { step: s, data: payload })
    commit(SET_COMMITTED_SNAPSHOT, { step: s, data: payload })

    if (!state.completedSteps.includes(s)) {
      commit(SET_COMPLETED_STEPS, [...state.completedSteps, s].sort((a, b) => a - b))
    }
  },

  /**
   * Descarta alterações não confirmadas com Continuar a partir do passo informado (4, 5 ou 6).
   */
  discardUncommittedFrom({ commit, state }, fromStep) {
    if (state.envioStatus === 'finalizado') return

    const start = Number(fromStep)
    if (!UPLOAD_PGR_PROTECTED_STEPS.includes(start)) return

    const initial = createInitialForms()

    UPLOAD_PGR_PROTECTED_STEPS.forEach((s) => {
      if (s >= start) {
        const snapshot =
          state.committedSnapshots[s] != null
            ? cloneFormSlice(state.committedSnapshots[s])
            : cloneFormSlice(initial[s])
        commit(RESET_STEP_FORM, { step: s, data: snapshot })
      }
    })

    commit(
      SET_COMPLETED_STEPS,
      state.completedSteps.filter((n) => n < start),
    )
  },

  discardAllProtectedSteps({ dispatch, state }) {
    if (state.envioStatus === 'finalizado') return
    dispatch('discardUncommittedFrom', UPLOAD_PGR_PROTECTED_STEPS[0])
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
}
